module.exports = __webpack_public_path__ + "static/media/Done.8ea1bb2e.png";